import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';

import ModalSuccessContainer from '@shared/components/modals/ModalSuccessContainer';
import { REQUEST_STATUS } from '@shared/constants/otherConstants';
import ModalErrorContainer from '@shared/components/modals/ModalErrorContainer';
import UtmsButton from '@shared/components/ui/UtmsButton';
import { TestplansTable } from '@pages/testplans/components/TestplansTable';
import { selectEditTestPlanErrorInfo, selectEditTestPlanStatus } from '@pages/testplans/store/selectors';
import { addTestcasesToTestplanRequest, editTestPlanReset, getTestPlanByIdRequest } from '@pages/testplans/store';

const IncludeToTestPlanModal = ({ open, setOpen, selectedTestPlanId, setSelectedTestPlanId, selectedTestCaseId }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const editTestPlanStatus = useSelector(selectEditTestPlanStatus);

    const handleClose = () => {
        setOpen(false);
    };

    const handleApply = () => {
        setOpen(false);
        dispatch(addTestcasesToTestplanRequest({ testplanId: selectedTestPlanId, testcase_ids: [selectedTestCaseId] }));
        setSelectedTestPlanId(null);
    };

    useEffect(() => {
        selectedTestPlanId && dispatch(getTestPlanByIdRequest(selectedTestPlanId));
    }, [dispatch, selectedTestPlanId]);

    return (
        <>
            {editTestPlanStatus === REQUEST_STATUS.SUCCESS && (
                <ModalSuccessContainer
                    object={t('test_case')}
                    action={t('added')}
                    resetActionCallback={editTestPlanReset}
                />
            )}
            {editTestPlanStatus === REQUEST_STATUS.ERROR && (
                <ModalErrorContainer
                    object={t('test_case_r')}
                    action={t('adding')}
                    resetActionCallback={editTestPlanReset}
                    errorSelector={selectEditTestPlanErrorInfo}
                />
            )}
            <Dialog
                PaperProps={{
                    sx: {
                        height: '600px',
                        maxWidth: '1360px',
                        backgroundColor: 'var(--section-bg-color)',
                    },
                }}
                fullWidth
                open={open}
            >
                <DialogTitle
                    sx={{
                        fontSize: 20,
                        letterSpacing: '0.15px',
                    }}
                >
                    {t('select') + ' ' + t('test_plan').toLowerCase()}
                </DialogTitle>
                <DialogContent>
                    <TestplansTable
                        dialogMode
                        selectedTestplanId={selectedTestPlanId}
                        setSelectedTestplanId={setSelectedTestPlanId}
                    />
                </DialogContent>
                <DialogActions>
                    <UtmsButton onClick={handleApply} disabled={!selectedTestPlanId}>
                        {t('apply')}
                    </UtmsButton>
                    <UtmsButton color="primary" onClick={handleClose}>
                        {t('cancel')}
                    </UtmsButton>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default IncludeToTestPlanModal;
